import type { SxProps, Theme } from "@mui/material";

/** Panel/card border — Repeat, Reminder, publish schedule, and matching inputs. */
export const composerPanelBorderSx = {
  borderRadius: 1,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
} as const;

const composerOutlinedInputRootSx = {
  borderRadius: 1,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "divider",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "divider",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
    borderWidth: "1px",
  },
} as const;

/** Outlined TextField / Select borders aligned with composer panels. */
export const composerOutlinedFieldSx = {
  "& .MuiOutlinedInput-root": composerOutlinedInputRootSx,
} as const;

/** Event detail fields: panel-matched borders + consistent height. */
export const composerEventDetailFieldSx = {
  "& .MuiOutlinedInput-root": {
    minHeight: 44,
    ...composerOutlinedInputRootSx,
  },
  "& .MuiInputBase-input": {
    py: 1.15,
    boxSizing: "border-box",
  },
} as const;

/** Apply panel-matched outlines to all fields inside the creation wizard modal. */
export const composerModalScopeSx = composerOutlinedFieldSx;

export type ComposerFieldSx = SxProps<Theme>;
